import { render, staticRenderFns } from "./ArrowBack.vue?vue&type=template&id=d847879c&scoped=true&"
import script from "./ArrowBack.vue?vue&type=script&lang=js&"
export * from "./ArrowBack.vue?vue&type=script&lang=js&"
import style0 from "./ArrowBack.vue?vue&type=style&index=0&id=d847879c&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d847879c",
  null
  
)

export default component.exports